import React,{useEffect,useState} from "react";
import styles from "./ThanksSection.module.css";
import icon1 from "../../assets/images/Icon1.svg";
import icon2 from "../../assets/images/Icon2.svg";
import icon3 from "../../assets/images/Icon3.svg";
import {HiArrowRight} from 'react-icons/hi';
import {Link,useLocation, useHistory} from 'react-router-dom';
import queryString from 'query-string'
import {confirmPayment} from '../../config/confirmPayment'

export default function ThanksSection(props) {

  const {search} = useLocation()
  const {provider, trxref, reference} = queryString.parse(search)
  const application_id = props.application_id
  const first = props.first
  const second = props.second
  const third = props.third

  const history = useHistory()


  return (
    <div>
      <div className={styles.first}>
        <h1 className={styles.firstHead}>Thank You!</h1>
        <h1 className={styles.firstHead2}>
          Your visa application payment was successful
        </h1>
        <br />
        <p className={styles.firstPera}>Order Details</p>
      </div>
      <div className={styles.second}>
        <h1 className={styles.secondHead}>Next Step</h1>
        <div className={styles.boxes}>
          <div className={styles.box}>
            <img src={icon1} alt="Icon 1" className={styles.image}  />
            <div className={styles.boxIn}>
                <h1 className={styles.boxHead}>Fill application form</h1>
                <p className={styles.boxPera}>Complete our biodata form and Upload all documents </p>
                <Link to={`/dashboard/my-applications/application-center/${application_id}`}>
                <p className={styles.boxEnd}>Start application&nbsp;&nbsp;<HiArrowRight size={20} color="#ffffff" style={{backgroundColor: "#F78500",height: "25px", width: "25px"}} /></p>
                </Link>
            </div>
          </div>
          <div className={styles.box1}>
            <img src={icon2} alt="Icon 2" className={styles.image1} />
            <div className={styles.boxIn1}>
                <h1 className={styles.box1Head}>Visa processing</h1>
                <p className={styles.box1Pera}>Visa will be applied on <span style={{color:"#FD6B3B"}}>{first}.</span><br /> Processing usually takes <span style={{color:"#FD6B3B"}}>{second}</span> Working Days </p>
            </div>
          </div>
          <div className={styles.box1}>
            <img src={icon3} alt="Icon 3" />
            <div className={styles.boxIn1}>
                <h1 className={styles.box1Head}>Fill application form</h1>
                <p className={styles.box1Pera}>Visa expected by <span style={{color:"#FD6B3B"}}>{third}.</span> Dowload Visa from Visapro trips section once approved.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
